import { useEnhancedReducer } from './use-enhanced-reducer';
const mediaGalleryReducer = (state, action) => {
    switch (action.type) {
        case 'SLIDE_CHANGE':
            return Object.assign(Object.assign({}, state), { activeIndex: action.index, animate: action.animate, dragEnabled: false, lastIndex: action.index, slidePosition: calculateSlidePosition(state.slideLength, action.index) });
        case 'DRAG_START':
            return Object.assign(Object.assign({}, state), { animate: false, dragEnabled: true, dragStartPosition: action.position, dragStartTime: new Date().getTime() });
        case 'DRAG_MOVE':
            return Object.assign(Object.assign({}, state), { activeIndex: action.index, slidePosition: calculateSlidePosition(state.slideLength, state.activeIndex) });
        case 'SET_SLIDE_LENGTH':
            return Object.assign(Object.assign({}, state), { slideLength: action.length, slidePosition: calculateSlidePosition(action.length, state.activeIndex) });
        case 'SET_SLIDE_KEYS':
            return Object.assign(Object.assign({}, state), { slideKeys: action.slideKeys });
        default:
            return state;
    }
};
const calculateSlidePosition = (length, index) => {
    if (length > 1) {
        return (100 / (length + 2)) * (index + 1);
    }
    return 0;
};
const initialState = {
    activeIndex: 0,
    lastIndex: 0,
    animate: false,
    dragStartPosition: 0,
    dragStartTime: 0,
    dragEnabled: false,
    slidePosition: 0,
    slideLength: 0,
    slideKeys: [],
};
export const useMediaGalleryReducer = () => {
    return useEnhancedReducer(mediaGalleryReducer, initialState);
};
